import script from "./UserFeedback.vue?vue&type=script&setup=true&lang=js"
export * from "./UserFeedback.vue?vue&type=script&setup=true&lang=js"

import "./UserFeedback.vue?vue&type=style&index=0&id=f8e2aa70&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f8e2aa70"]])

export default __exports__